function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTick = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 35 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-5779,-697)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,4341.5,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tick",
    transform: "matrix(1,0,0,1.03814,-186.946,180.525)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.384528,0,0,0.384631,1098.08,165.604)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1414.54,
    cy: 907.398,
    r: 44.397,
    style: {
      fill: "rgb(57,123,15)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.89328,0,0,0.863732,-7753.89,-2419.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10509.7,3399.17L10514.8,3404.31L10527.1,3390.29",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "3.49px"
    }
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTick);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Tick.a52c54466679f7d664621c81557a6eab.svg";